export const SETTING_CHECKOUT_PAGE_REQUEST = 'SETTING_CHECKOUT_PAGE_REQUEST'
export const SETTING_CHECKOUT_UPDATE_SETTING = 'SETTING_CHECKOUT_UPDATE_SETTING'
export const SETTING_CHECKOUT_SET_SETTING = 'SETTING_CHECKOUT_SET_SETTING'



// WEBPACK FOOTER //
// ./app/actions/setting/checkout/constant.js